import { useState, useEffect, useRef } from 'react';

/**
 * 计时器 Hook
 * 用于管理代码练习的计时功能
 */
export function useTimer() {
  const [timerRunning, setTimerRunning] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRunning) {
      timerRef.current = setInterval(() => {
        setElapsedTime(prev => prev + 1);
      }, 1000);
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [timerRunning]);

  const startTimer = () => {
    setTimerRunning(true);
    if (elapsedTime === 0) {
      setElapsedTime(0);
    }
  };

  const stopTimer = () => {
    setTimerRunning(false);
  };

  const resetTimer = () => {
    setTimerRunning(false);
    setElapsedTime(0);
  };

  return {
    timerRunning,
    elapsedTime,
    startTimer,
    stopTimer,
    resetTimer,
    toggleTimer: () => {
      if (timerRunning) {
        stopTimer();
      } else {
        startTimer();
      }
    }
  };
}

